<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Independent Review</h1>

        <section class="content-section">
            <p class="desc-text">Product review assessments are conducted through structured review procedures that may involve technology-assisted analysis, expert-assisted review, and independent third-party review support.</p>
            <p class="desc-text">Authentication determinations are based on the information available at the time of review, including submitted images, product details, supporting documentation, and marketplace risk indicators.</p>
            <p class="desc-text">Authentication services are intended solely to support marketplace trust and product transparency.</p>
        </section>

        <section class="content-section">
            <p class="desc-text">Authentication outcomes do not constitute:</p>
            <ul class="policy-list">
                <li>ownership verification</li>
                <li>legal certification</li>
                <li>financial guarantees</li>
                <li>investment evaluations</li>
                <li>resale value guarantees</li>
                <li>insurance coverage</li>
                <li>transaction guarantees</li>
            </ul>
        </section>

        <section class="content-section">
            <p class="desc-text">Additional information may be requested in cases where product review support cannot be reasonably completed using the submitted materials.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckIndependentReview'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
